export enum DocumentTypesString {
  'Invoice' = 1,
  'Findings document' = 3,
  'RFP Award Letter' = 9,
  'RFP Description' = 10,
  'Deal Association Template' = 11,
  'Statement of Work'=13,
};

export enum DocumentTypes {
  POEInvoice = 1,
  CustomerAcknowledgement = 2,
  POEDocument = 3,
  CustomerPOESurvey = 4,
  AdditionalDocument = 5,
  PartnerPOESurvey = 6,
  PrivatePartnerAccessList = 7,
  PrivateCustomerAccessList = 8,
  RequestForProposalAwardLetter = 9,
  RequestForProposalDescription = 10,
  DealAssociationTemplate = 11,
  SOW=13,
}